import { FC } from "react";

import {
    StyledCheckoutSection,
    StyledSectionText,
    StyledSectionTitle,
} from "./Styled";

interface CheckoutCompanyInfoProps {
    companyName: string;
    address: string;
    contragent: string;
}

export const CheckoutCompanyInfo: FC<CheckoutCompanyInfoProps> = ({
    companyName,
    address,
    contragent,
}) => {
    const fields = [
        { title: "Назва компанії", value: companyName },
        { title: "Адреса", value: address },
        { title: "Юридична особа", value: contragent },
    ];

    return (
        <>
            {fields.map(({ title, value }) => (
                <StyledCheckoutSection key={title}>
                    <StyledSectionTitle>{title}</StyledSectionTitle>
                    <StyledSectionText>{value || "-"}</StyledSectionText>
                </StyledCheckoutSection>
            ))}
        </>
    );
};
